import { type UseQueryResult, useQuery } from 'react-query';
import { VendorDesignationService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetVendorDesignationOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const vendorDesignationServiceOptions = useQuery(
    ['getVendorDesignationServiceOptions'],
    async () => {
      return await handleRequest(
        VendorDesignationService.getApiCustomerApiAppVendorDesignationVendorDesignations()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return vendorDesignationServiceOptions;
};

export default useGetVendorDesignationOptions;
